import { theme } from '@/styles/theme';
export const styles = {
  container: {
    paddingTop: '32px',
  },
  sameLineText: {
    display: 'flex',
    gap: 0.5,
  },
  subtitleEmail: {
    fontSize: '1.4rem',
    fontWeight: 400,
  },
  forgetCodeText: {
    fontSize: '1.2rem',
  },
  forgetCode: {
    fontWeight: 600,
    fontSize: '1.2rem',
  },
  canResend: {
    color: theme.palette.primary.main,
    cursor: 'pointer',
    fontWeight: 600,
    fontSize: '1.2rem',
  },
  cantResend: {
    color: theme.palette.text.secondary,
    fontWeight: 600,
    fontSize: '1.2rem',
    cursor: 'not-allowed',
  },
};
